/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'jquery',
	'underscore',
	'require',
	'../../lib/@waca/core-client/js/core-client/utils/Utils'
], function(View, $, _, require, CommonsUtils) {

	/**
	 * Represents a drop down menu that can be added to an app bar
	 */
	var Button = View.extend({
		events: {
			'primaryaction': '_handleClick',
			'mousedown': '_handleStartDrag',
			'dragdown': '_handleStartDrag'
		},
		baseClass: 'toolbar',

		/**
		 * Creates a new menu item
		 *
		 * @param spec -
		 *            The menu item spec
		 * @param root -
		 *            A reference to the root menu item, where items go if the app bar is collapsed horizontally
		 */
		init: function(spec, parentItem, toolbar) {
			this.group = null; //group can be set for sets of buttons that act as states of an action
			this.selected = false;
			this.toolbar = toolbar;
			_.extend(this, spec);
			Button.inherited('init', this, arguments);
			this.requireFn = this.requireFn || require;
		},

		_handleClick: function() {
			if (this.$('button').prop('disabled')) {
				return;
			}
			var dfd = null;
			if(this.actions) {
				dfd = this.actions.apply.apply(this, arguments);
			} else if (this.action) {
				dfd = this.action.apply(this, arguments);
			}

			if (this.arrow && dfd && dfd.then) {
				dfd.then(this.$el.addClass.bind(this.$el, 'open'));
			}

			if (this.$('button').prop('update')) {
				this.toolbar.updateButtons();
			}
		},

		_handleStartDrag: function() {
			if (this.$('button').prop('disabled')) {
				return;
			}
			if (this.startDrag) {
				this.startDrag.apply(this, arguments);
			}
		},

		/**
		 * Draws the MenuItem
		 */

		render: function() {
			//if the itemSpec indicates labelOnly, we render the button as launchable label
			if(this.labelOnly){
				this.$el.empty().prepend($(`<a class="ba-common-link" tabindex="0" aria-label="${this.label}">${this.label}</a>`));
				return this;
			}

			var $button;
			$button = $('<button></button>');
			// Sets the attribute only if value is defined. Helper to reduce complexity while doing validation.

			if (this.toolbar && this.toolbar.options) {
				if (this.text && !this.toolbar.options.iconOnly) {
					$button = $('<button>' + this.text + '</button>');
				}
				if (this.icon && !this.toolbar.options.textOnly) {
					CommonsUtils.setIcon($button, this.icon, this.label, this.label);
				}
			} else {
				if (this.text) {
					$button = $('<button>' + this.text + '</button>');
				}
				if (this.icon) {
					CommonsUtils.setIcon($button, this.icon, this.label, this.label);
				}
			}

			this._renderCoachMark();

			var _setAttr = (sAttr, sValue) => {
				if (sValue) {
					$button.attr(sAttr, sValue);
				}
			};
			// Adds the sClassname if it's defined to the element. Helper to reduce complexity while doing validation.
			var _addClass = ($el, className) => {
				if (className) {
					$el.addClass(className);
				}
			};

			if (!this.icon) {
				_setAttr('aria-label', this.label);
			}

			_setAttr('title', this.label);
			_setAttr('walkme-data-id', this.name);
			_addClass($button, this.className);

			_setAttr('id', this.id);
			_setAttr('accesskey', this.accesskey);


			if (typeof this.disabled === 'function') {
				if (this.disabled() === true) {
					$button.prop('disabled', true);
				}
			} else if (this.disabled === true) {
				$button.prop('disabled', true);
			}

			if (typeof this.update === 'function') {
				if (this.update() === true) {
					$button.prop('update', true);
				}
			} else if (this.update === true) {
				$button.prop('update', true);
			}

			if (this.hidden) {
				this.$el.hide();
			}

			let buttonContainerClass = this.baseClass + 'Icon ' + this.baseClass + 'Item';
			if($button.hasClass('buttonWithText')){
				buttonContainerClass+= ' buttonWithText';
			}

			this.$el
				.empty()
				.addClass(buttonContainerClass)
				.prepend($button);

			if (this.selected) {
				this.$el.addClass('selected');
			}
			_addClass(this.$el, this.group);

			if (this.arrow) {
				this.$el.append($('<div class="arrow-wrapper"><div class="arrow"></div></div>'));
			}
			this._renderDecorator();
			return this;
		},

		setFocus: function() {
			this.$('button').focus();
		},

		remove: function() {
			this._removeDecorator();
			Button.inherited('remove', this, arguments);
		},

		_renderCoachMark: function() {
			if(this.coachMark && this.coachMark.dashboard){
				const dashboard = this.coachMark.dashboard;
				const coachMarkOptions = {
					id: this.coachMark.id,
					title: this.coachMark.title,
					contents: this.coachMark.contents,
					placement: 'bottom',
					domElement: this.el
				};
				dashboard.prepareGlassOptions(coachMarkOptions);
				const coachMark = dashboard.getFeature('CoachMark');
				coachMark.addCoachMark(coachMarkOptions);
			}
		},

		_renderDecorator: function() {
			if (this.decoratorView) {
				const decoratorView = this.decoratorView;
				this.requireFn([decoratorView.viewModule], (ViewModule)=>{
					let viewOptions = typeof decoratorView.viewOptions === 'function' ? decoratorView.viewOptions() : decoratorView.viewOptions;
					viewOptions = viewOptions || {};
					viewOptions.containerNode = this.$('button');
					this._decorator = new ViewModule(viewOptions);
					this._decorator.render();
				});
			}
		},

		_removeDecorator: function() {
			if (this._decorator) {
				this._decorator.remove();
				this._decorator = null;
			}
		}
	});

	return Button;
});
